// src/utils/toast.ts
import ReceiptController from "./ReceiptController";

const PrinterController = {
  // printStatus: 0: 접수 전 / 1: 접수 후 / 2: 자동 접수 / 3: 재출력
  preparePrintData: async (
    oOrderData: any,
    printStatus: number,
    bPrintCustomerReceipt?: boolean,
    bPrintKitchenReceipt?: boolean
  ) => {
    function sleep(ms: number) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    }

    let sPrintData: any = "";
    let sOrderId = oOrderData.order_id;
    let sOrderSeq = oOrderData.child.order_seq;
    //let sQrCodeUrl = `http://192.168.168.37:11550/api/order/completeDelivery/${sOrderId}/${sOrderSeq}`;
    // let sQrCodeUrl = `${process.env.REACT_APP_API_CEO_URL}/order/delivery/${sOrderId}/${sOrderSeq}`;
    let sQrCodeUrl =
      `${process.env.REACT_APP_API_CEO_URL}/o/${sOrderId}`.replace(
        "https://",
        ""
      );
    // let sQrCodeUrl = `knock-knock.ivid.kr/store/manager/o/OT2CF19F389704180`;
    // let sQrCodeUrl = `knock-knock.ivid.kr/store/manager/o/aD2`;
    //console.log('oOrderData', oOrderData);

    if (bPrintCustomerReceipt === true || bPrintCustomerReceipt === undefined) {
      let sReceiptTpl: any = await ReceiptController.makeCustomerReceipt(
        oOrderData,
        sQrCodeUrl
      );
      //let sReceiptTplQr: any = await ReceiptController.makeCustomerReceiptQrMode(oOrderData, sQrCodeUrl);
      //console.log('sReceiptTpl', sReceiptTpl);
      //console.log('oOrderData', oOrderData);
      await sleep(500);
      await PrinterController.sendToPrinter(
        sReceiptTpl,
        "customer",
        printStatus
      );
    }

    if (bPrintKitchenReceipt === true || bPrintKitchenReceipt === undefined) {
      await sleep(500);
      let sKitchenReceiptTpl: any = await ReceiptController.makeKitchenReceipt(
        oOrderData
      );
      await PrinterController.sendToPrinter(
        sKitchenReceiptTpl,
        "kitchen",
        printStatus
      );
    }
  },

  sendToPrinter: async (
    sPrintData: string,
    sReceiptType: string,
    printStatus: number
  ) => {
    // console.log("sPrintData", sPrintData, "\n", sReceiptType, printStatus);
    //console.log('sReceiptType', sReceiptType);
    //console.log('sPrintDataQr', sPrintDataQr);
    try {
      if (window && window.parent) {
        window.parent.postMessage(
          JSON.stringify({
            action: "print_receipt",
            data: sPrintData,
            data_qr: "",
            receipt_type: sReceiptType,
            print_status: printStatus,
          }),
          "*"
        );
      }
    } catch (err) {}
  },
};

export default PrinterController;
